import { connect } from 'react-redux'
import PlayInUploadModal from './PlayInUploadModal'
import { hidePlayInUploadModal } from '../../dataStore/actions/ui/uiActions'

const mapDispatchToProps = dispatch => ({
  hideModal: () => dispatch(hidePlayInUploadModal())
})

export default connect(null, mapDispatchToProps)(PlayInUploadModal)
